<app-main class="fill flex flex-col" [class.dark-theme]="appStateService.isDarkMode()"></app-main>